/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_CopyInputs */



/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Tournaments_Calendar_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_copy = /** @type {((inputs?: Tournaments_Calendar_CopyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_CopyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiar link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia link")
	return /** @type {LocalizedString} */ ("Copy link")
});